// Imports: local files.
import ApiClient from '../../services/ApiClient';

// Action Types: Get Complete Formal Education Content.
export const GET_FORMAL_EDUCATION_START = 'GET_FORMAL_EDUCATION_START';
export const GET_FORMAL_EDUCATION_SUCCESS = 'GET_FORMAL_EDUCATION_SUCCESS';
export const GET_FORMAL_EDUCATION_FAILED = 'GET_FORMAL_EDUCATION_FAILED';
export const GET_FORMAL_EDUCATION_RESET = 'GET_FORMAL_EDUCATION_RESET';

// Action Types: Get Home Page Formal Education Content.
export const GET_HOME_PAGE_FORMAL_EDUCATION_START = 'GET_HOME_PAGE_FORMAL_EDUCATION_START';
export const GET_HOME_PAGE_FORMAL_EDUCATION_SUCCESS = 'GET_HOME_PAGE_FORMAL_EDUCATION_SUCCESS';
export const GET_HOME_PAGE_FORMAL_EDUCATION_FAILED = 'GET_HOME_PAGE_FORMAL_EDUCATION_FAILED';
export const GET_HOME_PAGE_FORMAL_EDUCATION_RESET = 'GET_HOME_PAGE_FORMAL_EDUCATION_RESET';

// Action Types: Create or Update Formal Education Content.
export const CREATE_OR_UPDATE_FORMAL_EDUCATION_START = 'CREATE_OR_UPDATE_FORMAL_EDUCATION_START';
export const CREATE_OR_UPDATE_FORMAL_EDUCATION_SUCCESS = 'CREATE_OR_UPDATE_FORMAL_EDUCATION_SUCCESS';
export const CREATE_OR_UPDATE_FORMAL_EDUCATION_FAILED = 'CREATE_OR_UPDATE_FORMAL_EDUCATION_FAILED';
export const CREATE_OR_UPDATE_FORMAL_EDUCATION_RESET = 'CREATE_OR_UPDATE_FORMAL_EDUCATION_RESET';

// Action Creators: Get Complete Formal Education Content.
const getFormalEducationStart = (payload) => ({
  type: GET_FORMAL_EDUCATION_START,
  payload,
});
const getFormalEducationSuccess = (payload) => ({
  type: GET_FORMAL_EDUCATION_SUCCESS,
  payload,
});
const getFormalEducationFailed = (payload) => ({
  type: GET_FORMAL_EDUCATION_FAILED,
  payload,
});
const getFormalEducationReset = () => ({ type: GET_FORMAL_EDUCATION_RESET });

// Action Creators: Get Home Page Formal Education Content.
const getHomePageFormalEducationStart = (payload) => ({
  type: GET_HOME_PAGE_FORMAL_EDUCATION_START,
  payload,
});
const getHomePageFormalEducationSuccess = (payload) => ({
  type: GET_HOME_PAGE_FORMAL_EDUCATION_SUCCESS,
  payload,
});
const getHomePageFormalEducationFailed = (payload) => ({
  type: GET_HOME_PAGE_FORMAL_EDUCATION_FAILED,
  payload,
});
const getHomePageFormalEducationReset = () => ({ type: GET_HOME_PAGE_FORMAL_EDUCATION_RESET });

// Action Creators: Create or Update Formal Education Content.
const createOrUpdateFormalEducationStart = (payload) => ({
  type: CREATE_OR_UPDATE_FORMAL_EDUCATION_START,
  payload,
});
const createOrUpdateFormalEducationSuccess = (payload) => ({
  type: CREATE_OR_UPDATE_FORMAL_EDUCATION_SUCCESS,
  payload,
});
const createOrUpdateFormalEducationFailed = (payload) => ({
  type: CREATE_OR_UPDATE_FORMAL_EDUCATION_FAILED,
  payload,
});
const createOrUpdateFormalEducationReset = () => ({ type: CREATE_OR_UPDATE_FORMAL_EDUCATION_RESET });

// Actions: Get Complete Formal Education Content (Separate Page).
export const getFormalEducation = (payload) => {
  return async (dispatch) => {
    dispatch(
      getFormalEducationStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    try {
      const { language } = payload;
      const result = await ApiClient.get('formalEducation', {
        params: { selectedLanguage: language },
      });
      if (result.data?.success) {
        const { formalEducation } = result.data.data;
        dispatch(
          getFormalEducationSuccess({
            loading: false,
            success: true,
            data: { formalEducation },
            error: false,
            errorMessage: null,
          })
        );
      } else {
        dispatch(
          getFormalEducationFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
      }
    } catch (error) {
      dispatch(
        getFormalEducationFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
    }
  };
};

// Actions: Clear Get Complete Formal Education Content.
export const clearGetFormalEducation = () => getFormalEducationReset();

// Actions: Get Home Page Formal Education Content.
export const getHomePageFormalEducation = (payload) => {
  return async (dispatch) => {
    dispatch(
      getHomePageFormalEducationStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    try {
      const { language } = payload;
      const result = await ApiClient.get('formalEducation/home', {
        params: { selectedLanguage: language },
      });
      if (result.data?.success) {
        const { formalEducation } = result.data.data;
        dispatch(
          getHomePageFormalEducationSuccess({
            loading: false,
            success: true,
            data: { formalEducation },
            error: false,
            errorMessage: null,
          })
        );
      } else {
        dispatch(
          getHomePageFormalEducationFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
      }
    } catch (error) {
      dispatch(
        getHomePageFormalEducationFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
    }
  };
};

// Actions: Clear Get Home Page Formal Education Content.
export const clearGetHomePageFormalEducation = () => getHomePageFormalEducationReset();

// Actions: Create or Update Formal Education Content.
export const createOrUpdateFormalEducation = (payload, options) => {
  return async (dispatch) => {
    dispatch(
      createOrUpdateFormalEducationStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    const {
      enHomePageTitle,
      enHomePageText,
      enSeparatePageTitle1,
      enSeparatePageText1,
      enSeparatePageTitle2,
      enSeparatePageText2,
      ukrHomePageTitle,
      ukrHomePageText,
      ukrSeparatePageTitle1,
      ukrSeparatePageText1,
      ukrSeparatePageTitle2,
      ukrSeparatePageText2,
      czHomePageTitle,
      czHomePageText,
      czSeparatePageTitle1,
      czSeparatePageText1,
      czSeparatePageTitle2,
      czSeparatePageText2,
    } = payload;
    const { toastNotification, onSuccessMessage, onFailMessage } = options;

    try {
      const result = await ApiClient.post('formalEducation', {
        enHomePageTitle,
        enHomePageText,
        enSeparatePageTitle1,
        enSeparatePageText1,
        enSeparatePageTitle2,
        enSeparatePageText2,
        ukrHomePageTitle,
        ukrHomePageText,
        ukrSeparatePageTitle1,
        ukrSeparatePageText1,
        ukrSeparatePageTitle2,
        ukrSeparatePageText2,
        czHomePageTitle,
        czHomePageText,
        czSeparatePageTitle1,
        czSeparatePageText1,
        czSeparatePageTitle2,
        czSeparatePageText2,
      });
      if (result.data?.success) {
        const { formalEducation } = result.data.data;
        dispatch(
          createOrUpdateFormalEducationSuccess({
            loading: false,
            success: true,
            data: { formalEducation },
            error: false,
            errorMessage: null,
          })
        );
        toastNotification('success', onSuccessMessage);
      } else {
        dispatch(
          createOrUpdateFormalEducationFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
        toastNotification('error', onFailMessage);
      }
    } catch (error) {
      dispatch(
        createOrUpdateFormalEducationFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
      toastNotification('error', onFailMessage);
    }
  };
};

// Actions: Clear Create or Update Formal Education Content.
export const clearCreateOrUpdateFormalEducation = () => createOrUpdateFormalEducationReset();
